import type { ContentBundle, Lang } from './types'

export async function fetchContent(lang: Lang): Promise<ContentBundle> {
  const r = await fetch(`/api/content?lang=${lang}`, { credentials: 'same-origin' })
  if (!r.ok) throw new Error(`content ${r.status}`)
  return r.json()
}

export function resolveImageUrl(key: string | null | undefined): string {
  if (!key) return ''
  if (key.startsWith('http://') || key.startsWith('https://')) return key
  if (key.startsWith('/')) return key
  return `/api/media/${key}`
}

/** Normalize a user-entered external URL. Ensures it is absolute (with scheme)
 *  so browsers don't treat it as a path relative to the current site.
 *  Returns null for empty/invalid input. */
export function externalUrl(raw: string | null | undefined): string | null {
  if (!raw) return null
  const v = raw.trim()
  if (!v) return null
  if (v.startsWith('mailto:') || v.startsWith('tel:')) return v
  if (/^https?:\/\//i.test(v)) return v
  return `https://${v.replace(/^\/+/, '')}`
}

export async function apiJson<T = unknown>(
  path: string,
  init?: RequestInit,
): Promise<T> {
  const r = await fetch(path, {
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
    ...init,
  })
  if (!r.ok) {
    let detail = ''
    try { detail = JSON.stringify(await r.json()) } catch { /* noop */ }
    throw new Error(`${init?.method ?? 'GET'} ${path} → ${r.status}${detail ? ' ' + detail : ''}`)
  }
  return r.json()
}
